var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"nav-icon",style:({
    width: `${_vm.size}px`,
    height: `${_vm.size}px`,
    maskImage: `url(${_vm.src})`,
    WebkitMaskImage: `url(${_vm.src})`,
  }),attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }